// src/store/index.js
import { createStore } from 'vuex';
import user from '@/store/modules/user';
import app from './modules/app';

export default createStore({
    modules: {
        user,
        app,
    },
});
